export const getLimitedTimeOfferPercent = (originalPrice: number, discountPrice: number) => {
  const discountAmount = originalPrice - discountPrice;
  return `-${Math.round((discountAmount / originalPrice) * 100)}%`;
};
